import { useEffect, useRef } from 'react';
import { message } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useResumeStore } from '../../store/resumeStore';
import { mapApiResumeToEditor } from './mapParsedResumeToState';
import {API} from "../../EndpPoints";
import ResumeParsingLoader from './ResumeParsingLoader';

export default function ImportResume() {
  const navigate = useNavigate();
  const location = useLocation();
  const [messageApi, contextHolder] = message.useMessage();
  const setResume = useResumeStore((s) => s.setResume);
  const resetTemplateSelection = useResumeStore((s) => s.resetTemplateSelection);
  let fileFromState = location.state?.file;
  const hasStartedParsing = useRef(false);
  const hasScheduledRedirect = useRef(false);

  useEffect(() => {
    if (!fileFromState) return;
    if (hasStartedParsing.current) return;
    hasStartedParsing.current = true;
    sendFileToBackend(fileFromState);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileFromState]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!fileFromState && !hasScheduledRedirect.current) {
        hasScheduledRedirect.current = true;
        messageApi.error('No file found. Please upload your resume again.');
        navigate('/dashboard');
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [fileFromState, messageApi, navigate]);

  const sendFileToBackend = async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await fetch(API.PARSE_RESUME, {
        method: 'POST',
        body: formData,
      });
      if (!res.ok) throw new Error('Backend parsing failed');
      const parsed = await res.json()
      const mappedData = mapApiResumeToEditor(parsed?.parsedData);

      resetTemplateSelection();
      setResume({
        ...mappedData,
        role: mappedData.roleTitle || ""
      });
      navigate("/resume/new");
    }
    catch (error) {
      console.error(error);
      messageApi.error('Failed to parse resume using AI.');
      navigate('/dashboard');
    }
  };
  return (
    <>
      {contextHolder}
      <ResumeParsingLoader />
    </>
  );
}
